import React from 'react';
import PropTypes from 'prop-types';
// Models
import mCustomer from 'models/customer';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { yesNoAsList, toBooleanOrNull, toIntegerOrNull } from 'utils/Tools';
import { dateGenerator } from 'utils/DateUtils';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';
import DateFilter from 'components/filters/DateFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import EntitySelectFieldFilter from 'installations/assets/entities/EntitySelectFieldFilter';

const CustomerFilters = ({
  timezone, disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    lastname, firstname, email, comments, accessWay, entityId, beginLastAccess, endLastAccess, synchronized, opBookingId,
  } = filters;
  // Dates
  const beginLastAccessDate = dateGenerator.dateFromTimezone(beginLastAccess.value, timezone);
  const endLastAccessDate = dateGenerator.dateFromTimezone(endLastAccess.value, timezone);

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('lastname') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.lastname"
              value={lastname.value}
              onChange={(value) => onFilterFieldChange('lastname', value)}
            />
          </div>
        )}
        {isFieldDisplayable('firstname') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.firstname"
              value={firstname.value}
              onChange={(value) => onFilterFieldChange('firstname', value)}
            />
          </div>
        )}
        {isFieldDisplayable('email') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.email"
              value={email.value}
              onChange={(value) => onFilterFieldChange('email', value)}
            />
          </div>
        )}
        {isFieldDisplayable('comments') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.comments"
              value={comments.value}
              onChange={(value) => onFilterFieldChange('comments', value)}
            />
          </div>
        )}
        {isFieldDisplayable('accessWay') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.accessWay"
              value={accessWay.value}
              onChange={(value) => onFilterFieldChange('accessWay', value)}
            />
          </div>
        )}
        {isFieldDisplayable('entityId') && (
          <div className="col-12 col-md-4 col-xl-3">
            <EntitySelectFieldFilter
              entityId={toIntegerOrNull(entityId.value)}
              onChange={(value) => onFilterFieldChange('entityId', value)}
            />
          </div>
        )}
        {isFieldDisplayable('beginLastAccess') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.afterLastAccess"
              type="begin"
              value={beginLastAccessDate}
              onChange={(value) => onFilterFieldChange('beginLastAccess', value)}
            />
          </div>
        )}
        {isFieldDisplayable('endLastAccess') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.beforeLastAccess"
              type="end"
              value={endLastAccessDate}
              onChange={(value) => onFilterFieldChange('endLastAccess', value)}
            />
          </div>
        )}
        {isFieldDisplayable('synchronized') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.synchronized"
              value={toBooleanOrNull(synchronized.value)}
              items={yesNoAsList}
              onChange={(value) => onFilterFieldChange('synchronized', value)}
            />
          </div>
        )}
        {isFieldDisplayable('opBookingId') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.opBookingId"
              value={opBookingId.value}
              onChange={(value) => onFilterFieldChange('opBookingId', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

CustomerFilters.propTypes = {
  timezone: PropTypes.string.isRequired,
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    lastname: listFilterShape,
    firstname: listFilterShape,
    email: listFilterShape,
    comments: listFilterShape,
    accessWay: listFilterShape,
    entityId: listFilterShape,
    beginLastAccess: listFilterShape,
    endLastAccess: listFilterShape,
    synchronized: listFilterShape,
    opBookingId: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mCustomer.listFeatures().searchFields)(CustomerFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/customers/CustomerFilters.js